import { getEnvRuntime, i18n } from '@cez-dje/providers';
import { QueryClientProvider } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { createRoot } from 'react-dom/client';
import { queryClient } from '@/api/queryClient';
import { type AppConfig, appConfigSchema } from '@/configuration/appConfiguration';
import { addTranslationResources } from '@/i18n/i18n';
import { routeTree } from '@/routeTree.gen';
import '@/assets/tailwind.css';

const root = createRoot(document.getElementById('root')!);

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createRouter>;
    context: {
      config: AppConfig;
    };
  }
}

let config: AppConfig;
try {
  config = await getEnvRuntime(appConfigSchema);
} catch (error: unknown) {
  console.error('Aplikaci se nepodařilo spustit kvůli konfiguraci.');
  throw error;
}

addTranslationResources();
document.title = i18n.t('form.documentTitle', { ns: 'snapForm' });

const router = createRouter({
  routeTree,
  context: {
    config,
  },
});

root.render(
  <QueryClientProvider client={queryClient}>
    <RouterProvider router={router} />
  </QueryClientProvider>
);
